import { Box, Button, HStack, Text, H3, Typography } from "components/ui";
import React, { forwardRef, useState } from "react";
import EnquireForm from "components/form/EnquireForm";
import Modal from "react-native-modal/dist/modal";
import { X } from "lucide-react-native";
import { Link } from "expo-router";

interface PageButtonProps {
	size: "small" | "medium" | "large";
	color?: string;
	variant: "primary" | "secondary" | "primary-light";
	text: string;
	href?: string;
	type: "enquireForm" | "pageLink";
}


export const PageButton = forwardRef<any, PageButtonProps>(({ size, variant, color, text, ...props }, ref) => {
	const [isOpenEnquireNow, setIsOpenEnquireNow] = useState(false);

	let colorValue;
	let convertedSize;

	switch (variant) {
		case "primary":
		case "primary-light":
			colorValue = "white";
			break;
		case "secondary":
		default:
			colorValue = "black";
			break;
	}

	switch (size) {
		case "small":
			convertedSize = "sm";
			break;
		case "medium":
			convertedSize = "md";
			break;
		case "large":
			convertedSize = "lg";
			break;
		default:
			convertedSize = "sm";
			break;
	}

	const handleClick = () => {
		if (props.type === "enquireForm") {
			setIsOpenEnquireNow(true);
		}
	};

	return (
		<Box sx={{ alignSelf: "flex-start" }} ref={ref}>
			{props.type === "enquireForm" ? (
				<Button
					borderWidth={1}
					borderColor={variant === "primary" || variant === "primary-light" ? "white" : "transparent"}
					sx={{ borderRadius: 6 }}
					variant={variant}
					alignSelf="flex-start"
					onPress={handleClick}
				>
					<HStack alignItems="center" gap={8}>
						<Box>
							<Text color={colorValue}>{text}</Text>
						</Box>
					</HStack>
				</Button>
			) : (
				<Link href={props.href || "/"} asChild>
					<Button variant={variant} alignSelf="flex-start">
						<HStack alignItems="center" gap={8}>
							<Box>
								<Text color={colorValue}>{text}</Text>
							</Box>
						</HStack>
					</Button>
				</Link>
			)}

			{props.type === "enquireForm" && (
				<Modal
					animationIn="fadeIn"
					animationOut="fadeOut"
					scrollOffset={1}
					onBackdropPress={() => setIsOpenEnquireNow(false)}
					isVisible={isOpenEnquireNow}
					style={{ maxWidth: 1240, marginLeft: "auto", marginRight: "auto", width: "100%" }}
				>
					<Box bg="$basicwhite" borderRadius={12}>
						<HStack
							alignItems="center"
							justifyContent="space-between"
							bg="$lighttealxlight"
							borderTopLeftRadius={12}
							borderTopRightRadius={12}
							paddingHorizontal={28}
							paddingVertical={20}
						>
							<H3>Enquire Now</H3>
							<Box>
								<Button onPress={() => setIsOpenEnquireNow(false)} gap={6}>
									<X />
									<Typography>Close</Typography>
								</Button>
							</Box>
						</HStack>
						<Box padding={24}>
							<EnquireForm setIsOpenEnquireNow={setIsOpenEnquireNow} />
						</Box>
					</Box>
				</Modal>
			)}
		</Box>
	);
});

export const PageButtonDefaultProps = {
	size: "small",
	variant: "secondary",
	color: "primary",
	text: "Click me",
};
